// Payment actions for payment methods
export const PAYMENT_ACTION_ADD = 'ADD'
export const PAYMENT_ACTION_HARD_DELETE = 'HARD_DELETE'
export const PAYMENT_ACTION_SOFT_DELETE = 'SOFT_DELETE'

// Payment actions for payments
export const PAYMENT_ACTION_PRE_AUTHORIZATION = 'PRE_AUTHORIZATION'
export const PAYMENT_ACTION_CANCELLATION_SEND = 'CANCELLATION_SEND'
export const PAYMENT_ACTION_CANCELLATION = 'CANCELLATION'
export const PAYMENT_ACTION_CAPTURE_SEND = 'CAPTURE_SEND'
export const PAYMENT_ACTION_CAPTURE = 'CAPTURE'
export const PAYMENT_ACTION_ADJUST_SEND = 'ADJUST_SEND'
export const PAYMENT_ACTION_ADJUST = 'ADJUST'
export const PAYMENT_ACTION_REFUND_SEND = 'REFUND_SEND'
export const PAYMENT_ACTION_REFUND = 'REFUND'

export const PAYMENT_ACTIONS = {
  [PAYMENT_ACTION_ADD]: 'resources.payment-actions.enums.types.addPaymentMethod',
  [PAYMENT_ACTION_HARD_DELETE]: 'resources.payment-actions.enums.types.hardDeletePaymentMethod',
  [PAYMENT_ACTION_SOFT_DELETE]: 'resources.payment-actions.enums.types.softDeletePaymentMethod',
  [PAYMENT_ACTION_PRE_AUTHORIZATION]: 'resources.payment-actions.enums.types.preAuthorisation',
  [PAYMENT_ACTION_CANCELLATION_SEND]: 'resources.payment-actions.enums.types.cancellationSend',
  [PAYMENT_ACTION_CANCELLATION]: 'resources.payment-actions.enums.types.cancellation',
  [PAYMENT_ACTION_CAPTURE_SEND]: 'resources.payment-actions.enums.types.captureSend',
  [PAYMENT_ACTION_CAPTURE]: 'resources.payment-actions.enums.types.capture',
  [PAYMENT_ACTION_ADJUST_SEND]: 'resources.payment-actions.enums.types.adjustSend',
  [PAYMENT_ACTION_ADJUST]: 'resources.payment-actions.enums.types.adjust',
  [PAYMENT_ACTION_REFUND_SEND]: 'resources.payment-actions.enums.types.refundSend',
  [PAYMENT_ACTION_REFUND]: 'resources.payment-actions.enums.types.refund',
}

export const PAYMENT_ACTION_REQUEST_SUFFIX = '_SEND'
export const PAYMENT_ACTION_REQUEST_ANSWER_DELAY_IN_HOURS = 24

export const PAYMENT_ACTION_STATUS_SUCCESS = 'SUCCESS'
export const PAYMENT_ACTION_STATUS_CHALLENGE = 'CHALLENGE'
export const PAYMENT_ACTION_STATUS_ERROR = 'ERROR'

export const PAYMENT_ACTION_REQUEST_STATUS_CONFIRMED = 'CONFIRMED'
export const PAYMENT_ACTION_REQUEST_STATUS_REFUSED = 'REFUSED'
export const PAYMENT_ACTION_REQUEST_STATUS_PENDING = 'PENDING'
export const PAYMENT_ACTION_REQUEST_STATUS_NO_ANSWER = 'NO_ANSWER'
export const PAYMENT_ACTION_REQUEST_STATUS_SEND_FAILED = 'SEND_FAILED'

export const PAYMENT_ACTION_STATUSES = {
  [PAYMENT_ACTION_STATUS_SUCCESS]: { label: 'resources.payment-actions.enums.status.success', color: 'success' },
  [PAYMENT_ACTION_STATUS_CHALLENGE]: { label: 'resources.payment-actions.enums.status.challenge', color: 'warning' },
  [PAYMENT_ACTION_STATUS_ERROR]: { label: 'resources.payment-actions.enums.status.error', color: 'error' },
  [PAYMENT_ACTION_REQUEST_STATUS_CONFIRMED]: {
    label: 'resources.payment-actions.enums.requestStatus.confirmed',
    color: 'success',
  },
  [PAYMENT_ACTION_REQUEST_STATUS_REFUSED]: {
    label: 'resources.payment-actions.enums.requestStatus.refused',
    color: 'error',
  },
  [PAYMENT_ACTION_REQUEST_STATUS_PENDING]: {
    label: 'resources.payment-actions.enums.requestStatus.pending',
    color: 'info',
  },
  [PAYMENT_ACTION_REQUEST_STATUS_NO_ANSWER]: {
    label: 'resources.payment-actions.enums.requestStatus.noAnswer',
    color: 'warning',
  },
  [PAYMENT_ACTION_REQUEST_STATUS_SEND_FAILED]: {
    label: 'resources.payment-actions.enums.requestStatus.sendFailed',
    color: 'error',
  },
}
